import { SelectedBaggageItem } from '../../../../BaggageService/types';

import { buildServiceKey } from './buildSelectedGdsServiceKeys';

/**
 * Исключает сегменты, где включенный багаж заменен выбранной доп-услугой (rfisc есть в `isReplacedBy`).
 */
export const filterSegmentIdsByReplacedBy = (
	segmentIds: string[],
	passengerId: string,
	replacedBy: string[] | null | undefined,
	selectedBaggageKeys: Set<string>
): string[] => {
	if (!replacedBy?.length || segmentIds.length === 0) {
		return segmentIds;
	}

	return segmentIds.filter(segmentId => {
		const isReplaced = replacedBy.some(rfisc =>
			selectedBaggageKeys.has(buildServiceKey(rfisc, passengerId, segmentId))
		);

		return !isReplaced;
	});
};

/**
 * Скрывает включенный багаж на сегментах, где выбран апгрейд из `isReplacedBy`.
 */
export const filterIncludedBaggageSegmentsByReplacedBy = (
	includedBaggages: SelectedBaggageItem[],
	selectedBaggageKeys: Set<string>
): SelectedBaggageItem[] => {
	return includedBaggages
		.map(item => {
			const passengerId = item.passengerId;
			const replacedBy = item.baggage?.isReplacedBy;
			const segmentIds = item.segmentIds ?? item.baggage?.includedSegments;

			if (
				!passengerId ||
				!replacedBy?.length ||
				!Array.isArray(segmentIds) ||
				segmentIds.length === 0 ||
				!item.baggage
			) {
				return item;
			}

			const filteredSegmentIds = filterSegmentIdsByReplacedBy(
				segmentIds,
				passengerId,
				replacedBy,
				selectedBaggageKeys
			);

			if (filteredSegmentIds.length === 0) {
				return null;
			}

			return {
				...item,
				segmentIds: filteredSegmentIds,
				baggage: {
					...item.baggage,
					includedSegments: filteredSegmentIds
				}
			};
		})
		.filter(Boolean);
};
